"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _Text = _interopRequireDefault(require("../Text"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Footer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "NavFooter__Footer",
  componentId: "cuwjvr-0"
})(function (_ref) {
  var theme = _ref.theme,
      collapsed = _ref.collapsed,
      pattern = _ref.pattern;
  return (0, _styledComponents.css)(["display:flex;align-items:flex-end;height:", ";border-radius:", " ", " ", " 0;", ";background-size:132px;"], theme.globalSizes.largest, theme.globalSizes.small, theme.globalSizes.large, theme.globalSizes.small, pattern && (0, _styledComponents.css)(["background-image:", ";"], collapsed ? 'none' : "url(".concat(pattern, ")")));
});
var BrandContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "NavFooter__BrandContainer",
  componentId: "cuwjvr-1"
})(function (_ref2) {
  var theme = _ref2.theme,
      collapsed = _ref2.collapsed;
  return (0, _styledComponents.css)(["display:flex;align-items:center;width:100%;height:", ";border-radius:", " ", " ", " 0;background:", ";p{white-space:nowrap;overflow:hidden;transition:", ";", "}"], theme.globalSizes.xxl, theme.globalSizes.large, theme.globalSizes.large, theme.globalSizes.small, theme.color.panel, _units.transition.textSlideInOutOpacityIndent, collapsed ? (0, _styledComponents.css)(["text-indent:-30rem;opacity:0;"]) : (0, _styledComponents.css)(["opacity:1;"]));
});
/**
 *
 * #### Sidebar footer component

To be displayed at the bottom of the `SideBar` component for general app branding. Designed to always be 100% width of its parent container.
 */

var NavFooter = function NavFooter(_ref3) {
  var _ref3$appName = _ref3.appName,
      appName = _ref3$appName === void 0 ? '' : _ref3$appName,
      _ref3$logo = _ref3.logo,
      logo = _ref3$logo === void 0 ? null : _ref3$logo,
      _ref3$pattern = _ref3.pattern,
      pattern = _ref3$pattern === void 0 ? null : _ref3$pattern,
      _ref3$collapsed = _ref3.collapsed,
      collapsed = _ref3$collapsed === void 0 ? false : _ref3$collapsed;
  return /*#__PURE__*/_react["default"].createElement(Footer, {
    element: "footer",
    collapsed: collapsed,
    pattern: pattern,
    padding: "none"
  }, /*#__PURE__*/_react["default"].createElement(BrandContainer, {
    element: "div",
    padding: "small",
    gap: "small",
    align: "center",
    collapsed: collapsed,
    role: "banner"
  }, logo, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    type: "bodyL"
  }, appName)));
};

var _default = NavFooter;
exports["default"] = _default;